import script from "./PasswordExpirationNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordExpirationNotification.vue?vue&type=script&setup=true&lang=js"

import "./PasswordExpirationNotification.vue?vue&type=style&index=0&id=c33d0096&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c33d0096"]])

export default __exports__